module.exports = __webpack_public_path__ + "static/media/admin_img_empresas.528161c1.svg";